import { useState } from "react";

export enum DialogState {
  NULL,
  CONTAINER_PHOTO_DIALOG,
  ALL_CONTAINER_PHOTO_DIALOG,
}

export const useShipmentDialogState = () => {
  const [dialogState, setDialogState] = useState<DialogState>(DialogState.NULL);
  const [containerIdForDialog, setContainerIdForDialog] = useState<
    number | undefined
  >();

  const openContainerPhotoDialog = (containerId: number) => {
    setContainerIdForDialog(containerId);
    setDialogState(DialogState.CONTAINER_PHOTO_DIALOG);
  };

  const openAllContainerPhotoDialog = () => {
    setDialogState(DialogState.ALL_CONTAINER_PHOTO_DIALOG);
  };

  const closeDialog = () => {
    setDialogState(DialogState.NULL);
    setContainerIdForDialog(undefined);
  };

  return {
    dialogState,
    containerIdForDialog,
    openContainerPhotoDialog,
    openAllContainerPhotoDialog,
    closeDialog,
  };
};
